module.exports = __webpack_public_path__ + "img/dataNormalization.36e648ef.png";